import  { useEffect, useState} from "react";
import { ErrorContext } from "../../utils/context/error";
import { getFindUserParams, getFindUserIdParams } from "../../services/user";
import IconM from "../dashboard/menu/icons/Icon";
import {useLocation, useNavigate} from 'react-router-dom';
import UserModal from "./usermodal";
import useTable from "../../hooks/table";
import TableFooter from "../../hooks/table/footer";
import FindModal from "./findmodal";
import KeyModal from "./keymodal";

function UserView() {
  const [user, setUser] = useState([]);
  const {setShowToast, setOpciones } = ErrorContext();
  const [UsuarioId, setUsuarioId] = useState(0);
  const [tag, setTag] = useState(0);
  const [estado, setEstado] = useState("AC");
  const [selectedRow, setSelectedRow] = useState(null);
  const [showM, setShowM] = useState(false);
  const [showB, setShowB] = useState(false);
  const [showK, setShowK] = useState(false);
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const { slice, range } = useTable(user, page, 10);  
  const location = useLocation();
  const [numeroNit, setNumeroNit] = useState("");
  const [nombre, setNombre] = useState("");
  const [estadof, setEstadoF] = useState("");
  const [consultando, setConsultando] = useState(false);

  
  //----- boton crear-Editar-Eliminar Area------------------------------------------------------------------------------ 
  const handleCrearArea = (tagId) => 
    {
      if ((selectedRow === null) && (tagId !== 0)) return
      if (tagId === 0) setUsuarioId(0);
      
      setShowM(true);
      setTag(tagId);
    };
  //----- Bloquea- Desbloquea ------------------------------------------------------------------------------------------ 
  const handleBloqueaArea = async (event) => 
    {
      setShowToast(false);
      const tagId = event.currentTarget.dataset.tag;
    };
  //--------------------------------------------------------------------------------------------------------------------
  const handlefilas = (Item,index) => 
    {
      setSelectedRow(index);
      setUsuarioId(Item.UsuarioId);
      setEstado(Item.Estado);
    };
  //--------------------------------------------------------------------------------------------------------------------
  const handleAsignaPerm =() =>
    {
      navigate('asignpermission', {state:{Id:UsuarioId, numeroNit, nombre, estadof}})
    }
  //--------------------------------------------------------------------------------------------------------------------
  const handleFiltrar = () =>
   {
     setShowB(true);
   }
  
  //--------------------------------------------------------------------------------------------------------------------
  const realizarConsulta = async (numeronit, nombreusr, estado) => 
   {
    setNumeroNit(numeronit);
    setNombre(nombreusr);
    setEstadoF(estado);
    setConsultando(true);
    const response = await getFindUserParams(numeronit, nombreusr, estado);
    if (response) 
     {
       if (response.status === 200) 
        {
          setUser(response.data.data);
          setConsultando(false);
        } 
       else 
        {
          setConsultando(false);
          const Mensaje = response.message;
          const opc = { type: "Danger", message: Mensaje, active: true };
          setOpciones(opc);
          setShowToast(true);
        }
      }
    };
  
  //----------------------------------------------------------------------------------------------------------------------
  const handleUsuarioGuardado = (usuarioGuardado) => 
    {
      setUser((prev) => {
       // Si ya existe, actualiza la fila
       const existe = prev.some(
          (u) => u.UsuarioId === usuarioGuardado.UsuarioId
        );

       if (existe) {
         return prev.map((u) =>
           u.UsuarioId === usuarioGuardado.UsuarioId
           ? usuarioGuardado
           : u
         );
       }
       // Si no existe, lo agrega a la grilla
       return [...prev, usuarioGuardado];
      });
    };

  //--------------------------------------------------------------------------------------------------------------------
  const handleKeyasign = () => 
    {
      if ((selectedRow === null))  return
      setShowK(true);
    };
  
  //---------------------------------------------------------------------------------------------------------------------
  const handleImport = () => 
    {
      navigate('userimport', {})
    };
 
  //----------------------------------------------------------------------------------------------------------------------
  useEffect(() => 
    {
      if (!location.state?.fromPermisos) return;
      if (location.state?.Id) 
        {
          if (location.state.fromPermisos) 
          {
            setUsuarioId(location.state.Id);
            realizarConsulta(location.state.numeroNit, location.state.nombre, location.state.estadof)
          }
        }
    }, [location.state]);   
  
  //--------------------------------------------------------------------------------------------------------------------
  return (
    <>
     <div className="">
      <div className="paneltitle">
          <label className="text-[1.0rem] font-light text-gray-400 leading-none"> Administración/Usuarios</label>
      </div>
      
        <div className="panelmenu">
            <button className="btnmenu" onClick={() => handleFiltrar()} >
              <IconM svg="find" className="iconmenu" title="find" />
              <span>Buscar</span>
            </button>
       
            <button className="btnmenu" onClick={() => handleCrearArea(0)} >
              <IconM svg="newfile" className="iconmenu" title="newfile" />
              <span>Nuevo</span>
            </button>
       
            <button className="btnmenu" id="Editar" disabled={selectedRow === null} onClick={() => handleCrearArea(1)}>
              <IconM svg="pencil" className="iconmenu" title="pencil" />
              <span>Editar</span>
            </button>
       
            <button className="btnmenu" id="Permiso" onClick={handleKeyasign} disabled={selectedRow === null}>
                 <IconM svg="password" className="iconmenu" title="userlock" />
                 <span>Clave</span>
            </button>
            <button className="btnmenu" id="import" onClick={handleImport} >
                 <IconM svg="import" className="iconmenu" title="import" />
                 <span>Importar</span>
            </button>

            {estado === "AC" ? (
              <button className="btnmenu" id="Bloquear" disabled={selectedRow === null} onClick={() => handleBloqueaArea('0')}>
                 <IconM svg="lock" className="iconmenu" title="lock" />
                 <span>Bloquear</span>
              </button>
              ) 
              : 
              (
                <button className="btnmenu" id="Desbloquear" disabled={selectedRow === null} onClick={() => handleBloqueaArea('1')}>
                   <IconM svg="dlock" className="iconmenu" title="dlock" />
                   <span>Desbloquear</span>
                </button>
              )}
              <button className="btnmenu" id="Permiso" onClick={handleAsignaPerm} disabled={selectedRow === null}>
                 <IconM svg="userlock" className="iconmenu" title="userlock" />
                 <span>Permiso</span>
              </button>
          </div>
          <div className="mt-2 rounded-lg border border-stone-200 overflow-x-auto">
           <table className="table-auto min-w-[700px] w-full">
               <thead className="border-b border-stone-200 text-sm font-medium ">
                 <tr>
                   <th className="px-2.5 py-2 text-start font-medium">Id.</th>
                   <th className="px-2.5 py-2 text-start font-medium">Código Usuario</th>
                   <th className="px-2.5 py-2 text-start font-medium">Nombre Usuario</th>
                   <th className="px-2.5 py-2 text-start font-medium">Identificación</th>
                   <th className="px-2.5 py-2 text-start font-medium">Correo Electrónico</th>
                   <th className="px-2.5 py-2 text-start font-medium">Teléfono</th>
                   <th className="px-2.5 py-2 text-start font-medium">Cargo</th>
                   <th className="px-2.5 py-2 text-start font-medium">Estado</th>
                 </tr>
               </thead>
               <tbody className="group text-sm text-stone-800 ">
                 {slice.map((item, index) => {
                     return (
                       <tr className={`border-b border-stone-200 last:border-0 ${selectedRow === index ? 'bg-blue-50 selected cursor-pointer' : ''}`} key={item.UsuarioId} id={`fila${item.UsuarioId}`} onClick={() => handlefilas(item,index)}>
                         <td>
                           <div className="flex items-center gap-3 text-sm text-current">
                             {item.UsuarioId}
                           </div>
                         </td>
                         <td>{item.CodigoUsr}</td>
                         <td>{item.NombreUsr}</td>
                         <td>{item.NumeroNit}</td>
                         <td>{item.Email}</td>
                         <td>{item.Telefono}</td>
                         <td>{item.NombreCar}</td>
                         <td className="center">
                              {item.Estado === "AC" ? (<span className="tagac">Activo</span>) : (<span className="tagan">Suspendido</span>)}
                         </td>          
                       </tr>
                  )})}
               </tbody>
             </table>
             </div>
             <TableFooter range={range} slice={slice} setPage={setPage} page={page} /> 
       </div>
       {showM && (<UserModal show={showM} handleshow= {setShowM} UsuarioI={UsuarioId} Tag={tag}   onGuardado={handleUsuarioGuardado}></UserModal>)}
       {showB && (<FindModal showB={showB} handleshow= {setShowB} realizarConsulta={realizarConsulta}></FindModal>)}
       {showK && (<KeyModal show={showK} handleshow= {setShowK} UsuarioI={UsuarioId}  onGuardado={handleUsuarioGuardado}></KeyModal>)}

       {consultando && (
          <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">
            <div className="bg-white rounded-lg p-6 shadow-lg text-center">
              <div className="animate-spin h-8 w-8 border-4 border-gray-300 border-t-blue-600 rounded-full mx-auto mb-4"></div>
              <p className="text-gray-700 font-medium">Consultando usuarios...</p>
              <p className="text-sm text-gray-500">Por favor espere</p>
            </div>
          </div>
       )}

  </>
  );
}
export default UserView;
